exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mainCardBG[data-v-17c80ea8]{border:none;box-shadow:0 4px 6px -1px rgba(0,0,0,.1),0 2px 4px -1px rgba(0,0,0,.06)}.table-responsive[data-v-17c80ea8]{border-radius:8px;overflow:hidden}.text-success[data-v-17c80ea8]{color:#2f855a!important}.text-danger[data-v-17c80ea8]{color:#c53030!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17c80ea8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/ulip/OceanFreightJobWiseProfitLoss.vue
// module id = 1407
// module chunks = 0